import { academyDateKey } from "../../utils/date.js";

// A view default only: fee calculation and other pages keep their own month rules.
export function paymentEntryMonth(now = new Date()) {
  const [year, month, day] = academyDateKey(now).split("-").map(Number);
  const next = month + (day > 15 ? 1 : 0);
  return `${year + (next > 12 ? 1 : 0)}-${
    String(next > 12 ? 1 : next).padStart(2, "0")
  }`;
}
